export class TranslationEn {

  static readonly dict =
    {
      'pages.security.login.title': 'pages.security.login.title',
      'pages.security.login.input_email_placeholder': 'pages.security.login.input_email_placeholder',
      'pages.security.login.input_password_placeholder': 'pages.security.login.input_password_placeholder',
      'pages.security.login.input_email_validation_required': 'pages.security.login.input_email_validation_required',
      'pages.security.login.input_password_validation_required': 'pages.security.login.input_password_validation_required',
      'pages.security.login.button_sign_in': 'pages.security.login.button_sign_in',
      'pages.security.login.modals.error.title': 'pages.security.login.modals.error.title',
      'pages.security.login.modals.error.body': 'pages.security.login.modals.error.body',
      'pages.security.login.modals.invalid.title': 'pages.security.login.modals.invalid.title',
      'pages.security.login.modals.invalid.body': 'pages.security.login.modals.invalid.body',
      'pages.security.login.forgot_password': 'pages.security.login.forgot_password',
      'pages.leads.lead': 'pages.leads.lead',
      'pages.leads.calendar': 'Calendar',
      'pages.leads.leads': 'pages.leads.leads',
      'pages.leads.status': 'pages.leads.status',
      'pages.leads.status.type.prequalification': 'pages.leads.status.type.prequalification',
      'pages.leads.status.type.buyed': 'pages.leads.status.type.buyed',
      'pages.leads.status.type.notbuyed': 'pages.leads.status.type.notbuyed',
      'pages.leads.pending': 'pages.leads.pending',
      'pages.leads.new': 'pages.leads.new',
      'pages.leads.news': 'pages.leads.news',
      'pages.leads.open': 'pages.leads.open',
      'pages.leads.assigned_to': 'pages.leads.assigned_to',
      'pages.leads.assigned': 'pages.leads.assigned',
      'pages.leads.bemycar_update': 'pages.leads.bemycar_update',
      'pages.leads.user': 'pages.leads.user',
      'pages.leads.brand': 'pages.leads.brand',
      'pages.leads.channel': 'pages.leads.channel',
      'pages.leads.type': 'pages.leads.type',
      'pages.leads.description_model': 'pages.leads.description_model',
      'pages.leads.model': 'Model',
      'pages.leads.dealer': 'pages.leads.dealer',
      'pages.leads.created_at': 'pages.leads.created_at',
      'pages.leads.updated_at': 'pages.leads.updated_at',
      'pages.leads.actions': 'pages.leads.actions',
      'pages.leads.type.used_vehicle': 'pages.leads.type.used_vehicle',
      'pages.leads.type.new_vehicle': 'pages.leads.type.new_vehicle',
      'pages.leads.type.after_sale': 'pages.leads.type.after_sale',
      'pages.leads.type.unknow': 'pages.leads.type.unknow',
      'pages.leads.type.': 'pages.leads.type',
      'pages.leads.status.new': 'pages.leads.status.new',
      'pages.leads.status.closed': 'pages.leads.status.closed',
      'pages.leads.status.archived': 'pages.leads.status.archived',
      'pages.leads.status.on_track': 'pages.leads.status.on_track',
      'pages.leads.status.cold': 'pages.leads.status.cold',
      'pages.leads.status.warm': 'pages.leads.status.warm',
      'pages.leads.status.hot': 'pages.leads.status.hot',
      'pages.leads.has_phone': 'pages.leads.has_phone',
      'pages.leads.has_email': 'pages.leads.has_email',
      'pages.leads.tags.new': 'pages.leads.tags.new',
      'pages.leads.tags.defeated': 'pages.leads.tags.defeated',
      'pages.leads.tags.24h': 'pages.leads.tags.24h',
      'pages.leads.tags.48h': 'pages.leads.tags.48h',
      'pages.leads.tags.today': 'pages.leads.tags.today',
      'pages.leads.tags.prequalification': 'pages.leads.tags.prequalification',
      'pages.leads.browse_files': 'pages.leads.browse_files',
      'pages.leads.drop_file_here': 'pages.leads.drop_file_here',
      'pages.leads.origin': 'Origin',
      'pages.leads.archive': 'pages.leads.archive',
      'shared.select_all': 'shared.select_all',
      'shared.label_not_found': 'Not found',
      'shared.create_new_origin': 'shared.create_new_origin',
      'shared.unselect_all': 'shared.unselect_all',
      'shared.search': 'shared.search',
      'shared.users': 'shared.users',
      'shared.modules': 'shared.modules',
      'shared.companies': 'shared.companies',
      'shared.channels': 'shared.channels',
      'shared.dealers': 'shared.dealers',
      'shared.brands': 'shared.brands',
      'shared.types': 'shared.types',
      'shared.select_element': 'shared.select_element',
      'shared.load_more': 'Load more',
      'leadType.new_vehicle': 'leadType.new_vehicle',
      'leadType.used_vehicle': 'leadType.used_vehicle',
      'leadType.after_sale': 'leadType.after_sale',
      'leadType.': 'leadType',
      'leadType.renting': 'Renting',
      'chart.lead_type.new_vehicle': 'chart.lead_type.new_vehicle',
      'chart.lead_type.used_vehicle': 'chart.lead_type.used_vehicle',
      'chart.lead_type.after_sale': 'chart.lead_type.after_sale',
      'chart.lead_type.': 'chart.lead_type',
      'chart.lead_type.renting': 'Renting',
      'chart.lead_type.rent_a_car': 'Rent a Car',
      'dealer.leads.chart.no_dealer': 'dealer.leads.chart.no_dealer',
      'pages.leads.select_all': 'pages.leads.select_all',
      'pages.leads.unselect_all': 'pages.leads.unselect_all',
      'pages.leads.search': 'pages.leads.search',
      'pages.leads.users': 'pages.leads.users',
      'pages.leads.channels': 'pages.leads.channels',
      'pages.leads.dealers': 'pages.leads.dealers',
      'pages.leads.brands': 'pages.leads.brands',
      'pages.leads.select_element': 'pages.leads.select_element',
      'pages.leads.select_element.error': 'Select at least one element',
      'pages.leads.name': 'pages.leads.name',
      'pages.leads.phone': 'pages.leads.phone',
      'pages.leads.email': 'pages.leads.email',
      'pages.leads.vat': 'pages.leads.vat',
      'pages.leads.others_f': 'pages.leads.others_f',
      'pages.leads.today': 'pages.leads.today',
      'pages.leads.yesterday': 'pages.leads.yesterday',
      'pages.leads.tomorrow': 'pages.leads.tomorrow',
      'pages.leads.hour': 'pages.leads.hour',
      'pages.leads.hours': 'pages.leads.hours',
      'pages.leads.day': 'pages.leads.day',
      'pages.leads.days': 'pages.leads.days',
      'pages.leads.month': 'pages.leads.month',
      'pages.leads.months': 'pages.leads.months',
      'pages.leads.from': 'pages.leads.from',
      'pages.leads.to': 'pages.leads.to',
      'pages.leads.apply': 'pages.leads.apply',
      'pages.leads.reset_filter': 'pages.leads.reset_filter',
      'pages.leads.appointment': 'Appointment',
      'pages.leads.appointments': 'Appointments',
      'pages.leads.reminder': 'pages.leads.reminder',
      'pages.leads.reminders': 'pages.leads.reminders',
      'pages.leads.transfereds': 'pages.leads.transfereds',
      'pages.leads.contacteds': 'pages.leads.contacteds',
      'pages.leads.select_option': 'pages.leads.select_option',
      'pages.leads.assign': 'pages.leads.assign',
      'pages.leads.transfer': 'pages.leads.transfer',
      'pages.leads.delete': 'pages.leads.delete',
      'pages.leads.comments': 'pages.leads.comments',
      'pages.leads.put_your_comment': 'pages.leads.put_your_comment',
      'pages.leads.custom_filter.advise': 'pages.leads.custom_filter.advise',
      'pages.leads.import.error.headers': 'pages.leads.import.error.headers',
      'pages.leads.import.error.type_not_found': 'pages.leads.import.error.type_not_found',
      'pages.leads.shipping': 'Shipping date',
      'pages.leads.no_potencial_sellers': 'pages.leads.no_potencial_sellers',
      'pages.leads.potencial_sellers': 'pages.leads.potencial_sellers',
      'pages.leads.accessible_lead': 'pages.leads.accessible_lead',
      'pages.leads.quotation.loading': 'pages.leads.quotation.loading',
      'pages.leads.quotation.vehicle': 'pages.leads.quotation.vehicle',
      'pages.leads.quotation.amount': 'pages.leads.quotation.amount',
      'pages.leads.quotation.status': 'pages.leads.quotation.status',
      'pages.leads.quotation.creationDate': 'pages.leads.quotation.creationDate',
      'pages.leads.quotation.dates': 'pages.leads.quotation.dates',
      'pages.leads.quotation.modificationDate': 'pages.leads.quotation.modificationDate',
      'pages.leads.quotation.quotationCreation': 'pages.leads.quotation.quotationCreation',
      'pages.leads.quotation.quotationModification': 'pages.leads.quotation.quotationModification',
      'pages.leads.quotation.contractDate': 'pages.leads.quotation.contractDate',
      'pages.leads.quotation.saleDate': 'pages.leads.quotation.saleDate',
      'pages.leads.quotation.quotationSoldClosingComment': 'pages.leads.quotation.quotationSoldClosingComment',
      'toaster.add_comment.success.title': 'toaster.add_comment.success.title',
      'toaster.add_comment.error.title': 'toaster.add_comment.error.title',
      'toaster.add_comment.success.body': 'toaster.add_comment.success.body',
      'toaster.title.lead_reminder_success': 'toaster.title.lead_reminder_success',
      'toaster.lead_reminder_success': 'toaster.lead_reminder_success',
      'toaster.lead_remove_event_success': 'toaster.lead_remove_event_success',
      'toaster.title.lead_remove_event_success': 'toaster.title.lead_remove_event_success',
      'toaster.lead_transfered_success': 'toaster.lead_transfered_success',
      'toaster.lead_transfered_success_body': 'toaster.lead_transfered_success_body',
      'toaster.lead.transfered.error': 'toaster.lead.transfered.error',
      'toaster.lead.transfered.error.body': 'toaster.lead.transfered.error.body',
      'toaster.lead.assigned_success': 'toaster.lead.assigned_success',
      'toaster.lead.assigned_sucess_body': 'toaster.lead.assigned_sucess_body',
      'toaster.lead.assigned.error': 'toaster.lead.assigned.error',
      'toaster.lead.get.error': 'toaster.lead.get.error', // TODO traducir
      'toaster.lead.assigned.error.body': 'toaster.lead.assigned.error.body',
      'toaster.lead.deleted.success': 'toaster.lead.deleted.success',
      'toaster.lead.deleted.success.body': 'toaster.lead.deleted.success.body',
      'toaster.lead.deleted.error': 'toaster.lead.deleted.error',
      'toaster.lead.deleted.error.body': 'toaster.lead.deleted.error.body',
      'toaster.new.lead.success': 'toaster.new.lead.success',
      'toaster.new.lead.success.body': 'toaster.new.lead.success.body',
      'toaster.new.lead.error': 'toaster.new.lead.error',
      'toaster.new.lead.error.body': 'toaster.new.lead.error.body',
      'toaster.edit.lead.success': 'toaster.edit.lead.success',
      'toaster.edit.lead.success.body': 'toaster.edit.lead.success.body',
      'toaster.edit.lead.error': 'toaster.edit.lead.error',
      'toaster.edit.lead.error.body': 'toaster.edit.lead.error.body',
      'toaster.call.error': 'toaster.call.error',
      'toaster.call.error.body': 'toaster.call.error.body',
      'toaster.call.error.body.another.started.call': 'toaster.call.error.body.another.started.call',
      'toaster.call.success': 'toaster.call.success',
      'toaster.call.success.body': 'toaster.call.success.body',
      'toaster.call.error.no_equal_lead_id': 'Problem retrieving lead information. Try again.',
      'toaster.email.error': 'toaster.email.error',
      'toaster.whatsapp.error': 'toaster.whatsapp.error',
      'toaster.integration.success': 'Successful integration',
      'toaster.integration.success_body': 'The lead has been correctly integrated with the external system',
      'toaster.integration.error': 'Unsuccessful integration',
      'modals.transfer_leads_title': 'modals.transfer_leads_title',
      'modals.select_user_to_transfer_lead': 'modals.select_user_to_transfer_lead',
      'page.mylead.no_especificado': 'page.mylead.no_especificado',
      'pages.mylead.details.createdat': 'pages.mylead.details.createdat',
      'pages.mylead.details.new_vehicle': 'pages.mylead.details.new_vehicle',
      'pages.mylead.details.used_vehicle': 'pages.mylead.details.used_vehicle',
      'pages.mylead.details.after_sale': 'pages.mylead.details.after_sale',
      'pages.mylead.details.unknow': 'pages.mylead.details.unknow',
      'pages.mylead.exclusive.lead': 'pages.mylead.exclusive.lead',
      'pages.mylead.remove': 'pages.mylead.remove',
      'pages.mylead.tab.concurrences': 'pages.mylead.tab.concurrences',
      'pages.mylead.tab.quotations': 'pages.mylead.tab.quotations',
      'pages.mylead.tab.events': 'pages.mylead.tab.events',
      'pages.mylead.tab.historic': 'pages.mylead.tab.historic',
      'pages.mylead.tab.interaction': 'pages.mylead.tab.interaction',
      'pages.mylead.tab.lead': 'pages.mylead.tab.lead',
      'pages.mylead.tab.metric': 'pages.mylead.tab.metric',
      'pages.mylead.appointment_remove': 'Appointment removed', // TODO translate
      'pages.notice.url.show_more': 'pages.notice.url.show_more',
      'pages.leads.leads_per_page': 'pages.leads.leads_per_page',
      'modals.archived_lead.title': 'modals.archived_lead.title',
      'modals.archive.comments.required': 'modals.archive.comments.required',
      'modals.archive.archived_option.required': 'modals.archive.archived_option.required',
      'modals.complete_name': 'modals.complete_name',
      'modals.importer.button': 'modals.importer.button',
      'modals.save.button': 'modals.save.button',
      'modals.next.button': 'modals.next.button',
      'modals.import.title': 'modals.import.title',
      'modals.importer.instructions.header': 'modals.importer.instructions.header',
      'modals.importer.instructions.format_should_csv': 'modals.importer.instructions.format_should_csv',
      'modals.importer.instructions.separator_fields': 'modals.importer.instructions.separator_fields',
      'modals.importer.instructions.delimiter_quotes': 'modals.importer.instructions.delimiter_quotes',
      'modals.importer.instructions.headers_valids': 'modals.importer.instructions.headers_valids',
      'modals.importer.instructions.headers_valids_here': 'modals.importer.instructions.headers_valids_here',
      'modals.importer.instructions.codification': 'modals.importer.instructions.codification',
      'modals.importer.instructions.info_channel': 'modals.importer.instructions.info_channel',
      'modals.importer.instructions.postal_code': 'modals.importer.instructions.postal_code',
      'modals.importer.file': 'modals.importer.file',
      'modals.importer.columns_is_not_correct': 'modals.importer.columns_is_not_correct',
      'modals.importer.dealer_not_found': 'modals.importer.dealer_not_found',
      'modals.importer.brand_not_found': 'modals.importer.brand_not_found',
      'modals.importer.channel_not_found': 'modals.importer.channel_not_found',
      'modals.importer.email_phone_is_required': 'modals.importer.email_phone_is_required',
      'modals.importer.phone_invalid': 'modals.importer.phone_invalid',
      'modals.importer.name_is_a_required_field': 'modals.importer.name_is_a_required_field',
      'modals.importer.validating_headers': 'modals.importer.validating_headers',
      'modals.importer.validating_lead_columns': 'modals.importer.validating_lead_columns',
      'modals.importer.check_fields': 'modals.importer.check_fields',
      'modals.importer.validating_channels': 'modals.importer.validating_channels',
      'modals.importer.validating_brands': 'modals.importer.validating_brands',
      'modals.importer.validating_dealers': 'modals.importer.validating_dealers',
      'modals.importer.validating_types': 'modals.importer.validating_types',
      'modals.importer.preparing_new_leads': 'modals.importer.preparing_new_leads',
      'modals.importer.creating_new_leads': 'modals.importer.creating_new_leads',
      'modals.send.button': 'modals.send.button',
      'modals.retry_import.button': 'modals.retry_import.button',
      'modals.cancel.button': 'modals.cancel.button',
      'modals.close.button': 'modals.close.button',
      'modals.close.comments.required': 'modals.close.comments.required',
      'modals.assign.button': 'modals.assign.button',
      'modals.delete.button': 'modals.delete.button',
      'modals.delete.comments.required': 'modals.delete.comments.required',
      'modals.transfer.button': 'modals.transfer.button',
      'modals.assign.leads.title': 'modals.assign.leads.title',
      'modals.close_sale.title': 'modals.close_sale.title',
      'modals.select_user_to_assign_lead': 'modals.select_user_to_assign_lead',
      'modals.delete.leads.title': 'modals.delete.leads.title',
      'modals.are.you.sure.delete.this.lead': 'modals.are.you.sure.delete.this.lead',
      'modals.reminder.title': 'modals.reminder.title',
      'modals.reminder.this_lead_already_has_a_reminder': 'modals.reminder.this_lead_already_has_a_reminder', // TODO Translate
      'modals.send_mail.title': 'modals.send_mail.title',
      'modals.send_mail.subject': 'modals.send_mail.subject',
      'modals.send_mail.write_your_email': 'modals.send_mail.write_your_email',
      'modals.send_mail.subject.required': 'modals.send_mail.subject.required',
      'modals.send_mail.body.required': 'modals.send_mail.body.required',
      'modals.call.title': 'modals.call.title',
      'modals.call.finish_call_form.on_track_status.required': 'modals.call.finish_call_form.on_track_status.required',
      'modals.call.finish_call_form.comments.required': 'modals.call.finish_call_form.comments.required',
      'modals.new.lead.title': 'modals.new.lead.title',
      'modals.edit.lead.title': 'modals.edit.lead.title',
      'modals.send_whatsapp.title': 'modals.send_whatsapp.title',
      'modals.send_whatsapp.write_your_whatsapp': 'modals.send_whatsapp.write_your_whatsapp',
      'modals.appointment.title': 'Appointment',
      'modals.appointment.this_lead_already_has_a_appointment': 'This lead already has an appointment', // TODO Translate
      'modals.appointment.choose_when': 'Appointment date',
      'modals.send_whats_app.comments.required': 'modals.send_whats_app.comments.required',
      'modals.on_track.title': 'modals.on_track.title',
      'modals.next_steps': 'modals.next_steps',
      'modals.on_track.on_track_status.required': 'modals.on_track.on_track_status.required',
      'modals.on_track.comments.required': 'modals.on_track.comments.required',
      'modals.comment.add_comment': 'modals.comment.add_comment',
      'funnel.total.leads': 'funnel.total.leads',
      'funnel.contacted.leads': 'funnel.contacted.leads',
      'funnel.visited.leads': 'funnel.visited.leads',
      'funnel.closed.leads': 'funnel.closed.leads',
      'lead_archived_type.not_contacted': 'lead_archived_type.not_contacted',
      'lead_archived_type.not_interested': 'lead_archived_type.not_interested',
      'lead_archived_type.other': 'lead_archived_type.other',
      'lead_archived_type.by_price': 'lead_archived_type.by_price',
      'lead_archived_type.by_appraisal': 'lead_archived_type.by_appraisal',
      'lead_archived_type.by_financing': 'lead_archived_type.by_financing',
      'lead_archived_type.immature': 'lead_archived_type.immature',
      'lead_archived_type.samebrand': 'lead_archived_type.samebrand',
      'lead_archived_type.anotherbrand': 'lead_archived_type.anotherbrand',
      'lead_archived_type.samebrand_dealership': 'lead_archived_type.samebrand_dealership',
      'lead_archived_type.anotherbrand_dealership': 'lead_archived_type.anotherbrand_dealership',
      'time.report.chart.contacted.customers': 'time.report.chart.contacted.customers',
      'time.report.chart.serie.contacted_leads': 'time.report.chart.serie.contacted_leads',
      'time.report.chart.serie.bussiness_contacted_leads': 'time.report.chart.serie.bussiness_contacted_leads',
      'time.report.chart.range.time.minutes': 'time.report.chart.range.time.minutes',
      'pages.metrics.sales.salesmen': 'pages.metrics.sales.salesmen',
      'pages.metrics.sales.salesman': 'pages.metrics.sales.salesman',
      'pages.metrics.sales.leads': 'pages.metrics.sales.leads',
      'pages.metrics.sales.archived.leads': 'pages.metrics.sales.archived.leads',
      'pages.metrics.sales.onTrack.leads': 'pages.metrics.sales.onTrack.leads',
      'pages.metrics.sales.contacted.leads': 'pages.metrics.sales.contacted.leads',
      'pages.metrics.sales.min.leads': 'pages.metrics.sales.min.leads',
      'pages.metrics.sales.visited.leads': 'pages.metrics.sales.visited.leads',
      'pages.metrics.sales.closed.leads': 'pages.metrics.sales.closed.leads',
      'pages.metrics.sales.interactions.count': 'pages.metrics.sales.interactions.count',
      'pages.metrics.sales.interactions.total': 'pages.metrics.sales.interactions.total',
      'channel.to.day.week.leads.chart.day.name': 'channel.to.day.week.leads.chart.day.name',
      'channel.to.day.week.leads.chart.day.name.monday': 'channel.to.day.week.leads.chart.day.name.monday',
      'channel.to.day.week.leads.chart.day.name.tuesday': 'channel.to.day.week.leads.chart.day.name.tuesday',
      'channel.to.day.week.leads.chart.day.name.wednesday': 'channel.to.day.week.leads.chart.day.name.wednesday',
      'channel.to.day.week.leads.chart.day.name.thursday': 'channel.to.day.week.leads.chart.day.name.thursday',
      'channel.to.day.week.leads.chart.day.name.friday': 'channel.to.day.week.leads.chart.day.name.friday',
      'channel.to.day.week.leads.chart.day.name.saturday': 'channel.to.day.week.leads.chart.day.name.saturday',
      'channel.to.day.week.leads.chart.day.name.sunday': 'channel.to.day.week.leads.chart.day.name.sunday',
      'channel.to.day.week.leads.chart.leads.count': 'channel.to.day.week.leads.chart.leads.count',
      'channel.to.day.week.leads.chart.bar': 'channel.to.day.week.leads.chart.bar',
      'channel.to.day.week.leads.chart.line': 'channel.to.day.week.leads.chart.line',
      'channel.to.day.week.leads.chart.stack': 'channel.to.day.week.leads.chart.stack',
      'channel.to.day.week.leads.chart.tiled': 'channel.to.day.week.leads.chart.tiled',
      'channel.to.day.week.leads.chart.undefined': 'channel.to.day.week.leads.chart.undefined',
      'channel.to.hour.leads.chart.undefined': 'channel.to.hour.leads.chart.undefined',
      'channel.to.hour.leads.chart.stack': 'channel.to.hour.leads.chart.stack',
      'channel.to.hour.leads.chart.tiled': 'channel.to.hour.leads.chart.tiled',
      'channel.to.hour.leads.chart.day.hour': 'channel.to.hour.leads.chart.day.hour',
      'channel.to.hour.leads.chart.leads.count': 'channel.to.hour.leads.chart.leads.count',
      'metrics.marketing.channel.leads.table.head.channel': 'metrics.marketing.channel.leads.table.head.channel',
      'metrics.marketing.channel.leads.table.head.leads': 'metrics.marketing.channel.leads.table.head.leads',
      'metrics.marketing.channel.leads.table.head.onTrack': 'metrics.marketing.channel.leads.table.head.onTrack',
      'metrics.marketing.channel.leads.table.head.contacted': 'metrics.marketing.channel.leads.table.head.contacted',
      'metrics.marketing.channel.leads.table.head.visited': 'metrics.marketing.channel.leads.table.head.visited',
      'metrics.marketing.channel.leads.table.head.closed': 'metrics.marketing.channel.leads.table.head.closed',
      'metrics.marketing.channel.leads.table.head.total': 'metrics.marketing.channel.leads.table.head.total',
      'metrics.marketing.channel.leads.table.channel.undefined': 'metrics.marketing.channel.leads.table.channel.undefined',
      'toast.title.lead_archived_success': 'toast.title.lead_archived_success',
      'toast.title.lead_close_error': 'toast.title.lead_close_error', // TODO traducir
      'toasts.messages.lead_archived_success': 'toasts.messages.lead_archived_success',
      'toasts.messages.lead_close_success': 'toasts.messages.lead_close_success',
      'toast.title.appointment_date_success': 'Appointment date success',
      'toasts.messages.appointment_date_success': 'Appontment date success',
      'pages.security.change_password.title': 'pages.security.change_password.title',
      'pages.security.change_password.password_placeholder': 'pages.security.change_password.password_placeholder',
      'pages.security.change_password.password_validation_required': 'pages.security.change_password.password_validation_required',
      'pages.security.change_password.confirm_password_placeholder': 'pages.security.change_password.confirm_password_placeholder',
      'pages.security.change_password.confirm_password_validation_required':
        'pages.security.change_password.confirm_password_validation_required',
      'pages.security.change_password.button_change_password': 'pages.security.change_password.button_change_password',
      'pages.security.change_password.modals.error.title': 'pages.security.change_password.modals.error.title',
      'pages.security.change_password.modals.error.body': 'pages.security.change_password.modals.error.body',
      'pages.security.change_password.modals.success.title': 'pages.security.change_password.modals.success.title',
      'pages.security.change_password.modals.success.body': 'pages.security.change_password.modals.success.body',
      'pages.security.change_password.passwords_must_be_equals': 'pages.security.change_password.passwords_must_be_equals',
      'pages.security.change_password.password_validation_number': 'pages.security.change_password.password_validation_number',
      'pages.security.change_password.password_validation_capital_case': 'pages.security.change_password.password_validation_capital_case',
      'pages.security.change_password.password_validation_special_char': 'pages.security.change_password.password_validation_special_char',
      'pages.security.change_password.password_validation_min_length': 'pages.security.change_password.password_validation_min_length',
      'pages.security.change_password.password_validation_max_length': 'pages.security.change_password.password_validation_max_length',
      'pages.security.reset_password_email.email_required': 'pages.security.reset_password_email.email_required',
      'pages.security.reset_password_email.email_placeholder': 'pages.security.reset_password_email.email_placeholder',
      'pages.security.reset_password_email.button_reset_password': 'pages.security.reset_password_email.button_reset_password',
      'pages.security.reset_password_email.title': 'pages.security.reset_password_email.title',
      'pages.security.reset_password_email.already_have_account': 'pages.security.reset_password_email.already_have_account',
      'pages.security.reset_password_email.sign_in': 'pages.security.reset_password_email.sign_in',
      'pages.security.reset_password_email.modals.error.title': 'pages.security.reset_password_email.modals.error.title',
      'pages.security.reset_password_email.modals.error.body': 'pages.security.reset_password_email.modals.error.body',
      'pages.security.reset_password_email.modals.success.title': 'pages.security.reset_password_email.modals.success.title',
      'pages.security.reset_password_email.modals.success.body': 'pages.security.reset_password_email.modals.success.body',
      'pages.security.reset_password.modals.success.title': 'pages.security.reset_password.modals.success.title',
      'pages.security.reset_password.modals.success.body': 'pages.security.reset_password.modals.success.body',
      'pages.security.reset_password.modals.error.title': 'pages.security.reset_password.modals.error.title',
      'pages.security.reset_password.modals.error.body': 'pages.security.reset_password.modals.error.body',
      'pwa.update_service.title': 'pwa.update_service.title',
      'pwa.update_service.body': 'pwa.update_service.body',
      'template.import.header.name_and_lastname': 'template.import.header.name_and_lastname',
      'template.import.header.phone': 'template.import.header.phone',
      'template.import.header.email': 'template.import.header.email',
      'template.import.header.vat': 'template.import.header.vat',
      'template.import.header.channel': 'template.import.header.channel',
      'template.import.header.origin': 'template.import.header.origin',
      'template.import.header.type': 'template.import.header.type',
      'template.import.header.brand': 'template.import.header.brand',
      'template.import.header.description_model': 'template.import.header.description_model',
      'template.import.header.dealer': 'template.import.header.dealer',
      'template.import.header.comment': 'template.import.header.comment',
      'template.import.name_file': 'template.import.name_file',
      'error.validations.this_field_is_required': 'error.validations.this_field_is_required',
      'error.lead_must_be_new_or_on_track': 'error.lead_must_be_new_or_on_track',
      'error.validations.date_should_be_major_that_actual': 'error.validations.date_should_be_major_that_actual',
      'error.email_is_not_valid': 'error.email_is_not_valid',
      'error.lead_assigned_another_user': 'error.lead_assigned_another_user',
      'error.lead_must_be_archived_or_on_track': 'error.lead_must_be_archived_or_on_track',
      'error.lead_in_call': 'error.lead_in_call',
      'errors.event_no_added': 'errors.event_no_added',
      'errors.event_should_date_greater_that_current': 'errors.event_should_date_greater_that_current',
      'call.started.call': 'call.started.call',
      'call.has.another.started.call': 'call.has.another.started.call',
      'call.view.lead': 'call.view.lead',
      'call.view.lead_with_link': 'call.view.lead_with_link',
      'error.user_in_call': 'error.user_in_call',
      'error.lead_closed': 'error.lead_closed',
      'error.not_found.lead': 'error.not_found.lead',
      'error.not_found.company': 'error.not_found.company', // TODO translate
      'error.lead_allready_assigned': 'error.lead_allready_assigned',
      'error.operation_not_allowed': 'error.operation_not_allowed',
      'error.found.external_system': 'This lead has already been sent to the external system',
      'error.not_found.external_system': 'External system not found',
      'error.thrift_response.integration': 'Error integrating lead with external system',
      'menu.metrics.title': 'menu.metrics.title',
      'menu.metrics.sales.title': 'menu.metrics.sales.title',
      'menu.metrics.marketing.title': 'menu.metrics.marketing.title',
      'menu.analytics.title': 'menu.analytics.title',
      'menu.login.title': 'menu.login.title',
      'menu.login.change.password.title': 'menu.login.change.password.title',
      'menu.login.logout.title': 'menu.login.logout.title',
      'menu.leads.title': 'menu.leads.title',
      'menu.reporting.title': 'menu.reporting.title',
      'menu.home': 'Home',
      'menu.dashboard': 'Dashboard',
      'menu.working_hours': 'Working hours',
      'auth.labels.logout': 'auth.labels.logout',
      'filters.title': 'filters.title',
      'filters.contact.undefined': 'Name / E-mail / Phone',
      'filters.filter_by_name': 'Name',
      'filters.filter_by_email': 'E-mail',
      'filters.filter_by_phone': 'Phone',
      'filters.error.three_chars_needed.text': '* Must contain at least 3 characters',
      'filters.error.three_chars_needed.phone': '* Must contain at least 3 digits',
      'filters.in_call': 'In call',
      'filters.transferred_not_received': 'Transf. not received',
      'time.abrv_seconds': 'time.abrv_seconds',
      'time.abrv_minutes': 'time.abrv_minutes',
      'time.abrv_hours': 'time.abrv_hours',
      'pages.marketing.inboud_leads_per_channels_day_week': 'pages.marketing.inboud_leads_per_channels_day_week',
      'pages.marketing.inboud_leads_per_channels': 'pages.marketing.inboud_leads_per_channels',
      'pages.sales.sales_funnel': 'pages.sales.sales_funnel',
      'pages.marketing.conversion_indicators': 'pages.marketing.conversion_indicators',
      'pages.sales.time_reports': 'pages.sales.time_reports',
      'pages.sales.time_reports_by_user': 'pages.sales.time_reports_by_user',
      'pages.historic.inboud_leads': 'pages.historic.inboud_leads',
      'pages.historic.duration_interaction': 'pages.historic.duration_interaction',
      'pages.historic.not_contacted': 'pages.historic.not_contacted',
      'pages.historic.status_label': 'pages.historic.status_label',
      'pages.historic.lead_assigned_to': 'pages.historic.lead_assigned_to',
      'pages.historic.lead_transfered_to': 'pages.historic.lead_transfered_to',
      'pages.historic.scheduled_appointment': 'Scheduled appointment',
      'pages.historic.for_the_day': 'pages.historic.for_the_day',
      'pages.historic.at': 'pages.historic.at',
      'pages.historic.show_mail': 'pages.historic.show_mail',
      'pages.historic.hidden_mail': 'pages.historic.hidden_mail',
      'pages.historic.show_whatsapp': 'pages.historic.show_whatsapp',
      'pages.historic.hidden_whatsapp': 'pages.historic.hidden_whatsapp',
      'pages.schedule.no_future_events': 'pages.schedule.no_future_events',
      'pages.schedule.events_to_manage': 'pages.schedule.events_to_manage',
      'pages.reporting.tabtitle.bdc': 'pages.reporting.tabtitle.bdc',
      'pages.reporting.tabtitle.leads': 'pages.reporting.tabtitle.leads',
      'pages.reporting.tabtitle.sales': 'pages.reporting.tabtitle.sales',
      'pages.reporting.tabtitle.marketing': 'pages.reporting.tabtitle.marketing',
      'pages.reporting.bdc.bdctimes': 'pages.reporting.bdc.bdctimes',
      'pages.reporting.download': 'pages.reporting.download',
      'header.select_company': 'header.select_company',
      'table.no_data_display': 'table.no_data_display', // TODO translate
      'calendar.add_event': 'calendar.add_event',
      'chat.show_hidden': 'Show/Hidden chat',
      'info.coming_soon': 'Coming soon',
      'info.new_content': 'New!',
      'planning.date': 'Date',
      'planning.user': 'User',
      'planning.lead': 'Lead',
      'planning.company': 'planning.company',
      'planning.comment': 'Commentary',
      'planning.getting_events': 'Recuperando eventos',
      'planning.no_events': 'No events.',
      'user.profile': 'Profile',
      'user.rules': 'Assignment rules',
      'user.email': 'Email',
      'user.schedule': 'Schedule',
      'user.password': 'Password',
      'user.role.legend': 'user.role.legend',
      'user.role.role_superadmin': 'user.role.role_superadmin',
      'user.role.role_user': 'user.role.role_user',
      'user.role.role_admin': 'user.role.role_admin',
      'user.role.role_bdc': 'user.role.role_bdc',
      'user.role.role_dapda': 'user.role.role_dapda',
      'filters.no_report': 'No report',
      'filters.yes_come': 'Yes come',
      'filters.not_come': 'Not come',
      'brand.leads.chart.no_brand': 'No brand',
      'help.assignment_rules_configuration': 'help.assignment_rules_configuration',
      'pages.profile.rules.positive_rules': 'pages.profile.rules.positive_rules',
      'pages.profile.rules.active': 'pages.profile.rules.active',
      'toaster.new.rule.error': 'toaster.new.rule.error',
      'toaster.new.rules.success.body': 'toaster.new.rules.success.body',
      'toaster.new.rule.unhandled_error': 'toaster.new.rule.unhandled_error',
      'toaster.new.repeated_rule.error.title': 'toaster.new.repeated_rule.error.title',
      'toaster.new.repeated_rule.error.body': 'toaster.new.repeated_rule.error.body',
      'help.assignment_rules.simulator': 'help.assignment_rules.simulator',
      'legend.filter.last_modification': 'legend.filter.last_modification',
      'leadType.appraisal': 'leadType.appraisal',
      'leadType.spare_parts': 'leadType.spare_parts',
      'chart.lead_type.appraisal': 'chart.lead_type.appraisal',
      'chart.lead_type.spare_parts': 'chart.lead_type.spare_parts',
      'pages.leads.type.appraisal': 'pages.leads.type.appraisal',
      'pages.leads.type.spare_parts': 'pages.leads.type.spare_parts',
      'pages.mylead.details.appraisal': 'pages.mylead.details.appraisal',
      'pages.mylead.details.spare_parts': 'pages.mylead.details.spare_parts',
      'leadType.km0': 'leadType.km0',
      'chart.lead_type.km0': 'chart.lead_type.km0',
      'pages.leads.type.km0': 'pages.leads.type.km0',
      'pages.mylead.details.km0': 'pages.mylead.details.km0',
      'error.fail_comunications_with_woice': 'error.fail_comunications_with_woice',
      'error.woice_token_not_received': 'error.woice_token_not_received',
    };

}
